import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

import { EventService } from '../../../services/events/event.service';

@Component({
  selector: 'app-event-multiday',
  templateUrl: './event-multiday.component.html',
  styleUrls: ['./event-multiday.component.css'],
})
export class EventMultidayComponent implements OnInit, OnChanges {
  @Input() agnostic: boolean = false;

  /**
   * Events to show
   */
  @Input() events: Array<any> = [];

  /**
   * Last date for header
   * @type {string}
   */
  lastDatePosition: string;

  /**
   * Emit event to edit an event
   * @param {EventEmitter<number> = new EventEmitter(} ) editEvent variable name
   */
  @Output() editEvent: EventEmitter<number> = new EventEmitter();

  /**
   * Emit event to show an event
   * @param {EventEmitter<number> = new EventEmitter(} ) showEvent variable
   */
  @Output() showEvent: EventEmitter<number> = new EventEmitter();

  /**
   * Constructor
   */
  constructor(private eventService: EventService) {}

  // Component lifecycle events

  /**
   * Called on component initialization
   */
  ngOnInit() {}

  /**
   * Called when variables in the component change
   * @param {SimpleChanges} changes Angular changes object
   */
  ngOnChanges(changes: SimpleChanges) {
    if (changes.events && changes.events.currentValue) {
      for (let event_obj of this.events) event_obj.event_title = this.eventService.getEventTitle(event_obj.start, event_obj.end, event_obj.s_offset, event_obj.e_offset);
      if (this.events[0]) this.lastDatePosition = this.events[0].date_position;
    }
  }

  // Component methods

  /**
   * Set last date position for header
   * @param  {string} newDatePosition New date position
   * @return {string}                 Date position after set
   */
  setLastDatePosition(newDatePosition: string): string {
    this.lastDatePosition = newDatePosition;
    return this.lastDatePosition;
  }

  activateIntranet(intranetId: number): void {
    if (!intranetId) return;

    const value = String(intranetId);
    window.sessionStorage.setItem('intranetId', value);
    window.localStorage.setItem('intranetId', value);
    document.cookie = `intranetId=${encodeURIComponent(value)}; path=/`;
  }

  toggleEvent(event: any): void {
    if (this.agnostic) this.activateIntranet(event.intranet_id);
    event.expanded = !event.expanded;
  }

  openEvent(event: any): void {
    this.activateIntranet(event.intranet_id);
    window.location.href = `/events?show_event_id=${event.event_id || event.id}`;
  }

  openMatter(event: any): void {
    this.activateIntranet(event.intranet_id);
    window.location.href = `/matters/${event.matter_id}`;
  }
}
